// extracted by mini-css-extract-plugin
export default {"handle":"tvrV8F"};